module.exports = __webpack_public_path__ + "img/rewards-fill.a712286c.png";